import styled from '@emotion/styled';
import { Button, Typography } from '@mui/material';
import { OptimizedImage } from '@web/common/components/optimized-image';
import NextLink from 'next/link';
import { FC } from 'react';

const MainContainer = styled.div`
  text-align: center;
  a {
    min-width: 300px;
  }
  ${props => props.theme.breakpoints.down('sm')} {
    a {
      width: 100%;
    }
  }
`;

export const EmptyProductList: FC = () => (
  <MainContainer>
    <OptimizedImage src="/icons/empty-cart.svg" width="236" height="236" />
    <Typography variant="h3" paragraph>
      Eita! Não tem nada aqui
    </Typography>
    <Typography variant="subtitle1" gutterBottom>
      Infelizmente nosso estagiário não cadastrou os produtos desta categoria :/
    </Typography>
    <Typography variant="body2" paragraph>
      Volte para a loja e adicione outros produtos
    </Typography>
    <NextLink href="/loja" passHref>
      <Button color="primary" variant="contained" size="large">
        Voltar para a loja
      </Button>
    </NextLink>
  </MainContainer>
);
